/**
 * Tracks changes in a category's prompt data
 * @param {Object} category - The category
 * @param {string} newImagePrompt - The new image prompt
 * @param {string} newVideoPrompt - The new video prompt
 * @param {Set} changedCategories - Set to track changed categories
 * @returns {boolean} - Whether the category was changed
 */
export const trackPromptChanges = (category, newImagePrompt, newVideoPrompt, changedCategories) => {
  if (!category) return false

  const originalImagePrompt = category.prompt?.image_prompt || ''
  const originalVideoPrompt = category.prompt?.video_prompt || ''

  const hasChanges = newImagePrompt !== originalImagePrompt || newVideoPrompt !== originalVideoPrompt

  if (hasChanges) {
    // Store temporary changes
    if (!category.prompt) category.prompt = {}
    category.prompt.tempImagePrompt = newImagePrompt
    category.prompt.tempVideoPrompt = newVideoPrompt
    category.hasPromptChanges = true
    changedCategories.add(category.id)
    return true
  } else {
    category.hasPromptChanges = false
    changedCategories.delete(category.id)
    return false
  }
}
